import React, { useEffect } from "react";
import { Switch, Route } from "react-router-dom";
import AuthenticatedRoute from "./AuthenticatedRoute";
import LoginPageMfa from "./LoginPageMfa";
import PageRoute from "./PageRoute";

export const App = () => {
  useEffect(() => {
    // set base URL for requests
    const origin = window.location.origin;
    document.head.innerHTML =
      document.head.innerHTML + "<base href='" + origin + "' />";
  }, []);

  console.log("app render");

  return (
    <Switch>
      <Route path="/login" component={() => <LoginPageMfa />} />
      <AuthenticatedRoute
        path={"*"}
        component={() => <PageRoute />}
        redirectPath="/login"
      />
    </Switch>
  );
};
